/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import RadioWidget from './RadioWidget';

export default function ActionRadioWidget(props) {
  const event = props.uiSchema?.['ui:actionEvent'];

  const actionChange = (value) => {
    props.registry.triggerPostProcess(props.id, value, event);
    props.onChange(value);
  };

  return <RadioWidget {...props} onChange={actionChange} />;
}
